<script setup lang="ts">
import { computed, watch } from 'vue';
import { useBreadcrumbStore } from '@menu-lib/breadcrumb/breadcrumbStore';
import { useRoute } from 'vue-router';
import FadeSlideTransition from '@shared/animation/transitions/FadeSlideTransition/FadeSlideTransition.vue';
import VPageContainer from '@shared/layout/VPageContainer/VPageContainer.vue';
import instellingenRoutes from '@crm-lib/routes/instellingen.routes';
import InstellingenMenu from './menu/InstellingenMenu.vue';

const currentRoute = useRoute();

const tabName = computed(
  () =>
    `${currentRoute?.meta?.label}${currentRoute?.params?.polisnummer ? ` ${currentRoute?.params?.polisnummer}` : ''}`,
);

const breadcrumbStore = useBreadcrumbStore();

const breadcrumbs = computed(() => {
  const base = { name: 'Instellingen', link: '' };
  const tab = { name: tabName.value || '', link: '' };

  if (!tabName.value) return [base];
  return [base, tab] as Array<{ name: string; link: string }>;
});

watch(breadcrumbs, (b) => (breadcrumbStore.breadcrumbs = b));
</script>

<template>
  <div class="flex h-full flex-col">
    <div class="relative flex grow flex-col xl:flex-row">
      <InstellingenMenu :routes="instellingenRoutes" />
      <RouterView v-slot="{ Component }">
        <FadeSlideTransition direction="down" mode="out-in">
          <KeepAlive>
            <VPageContainer
              v-if="!currentRoute.meta.pagina"
              container-size="xl"
              :title="currentRoute.meta.label as string"
            >
              <component :is="Component" />
            </VPageContainer>
            <component v-else :is="Component" />
          </KeepAlive>
        </FadeSlideTransition>
      </RouterView>
    </div>
  </div>
</template>
